import React from 'react';
import Card from '@mui/material/Card';
import {
  InputAdornment,
  InputBase,
  MenuItem,
  Select,
  Skeleton
} from '@mui/material';
import { Box, CardContent, Grid } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SearchSharpIcon from '@mui/icons-material/SearchSharp';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%'
  },
  search: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingLeft: theme.spacing(1.75),
    paddingTop: theme.spacing(-1),
    marginBottom: theme.spacing(1),
    width: '100%'
  },
  searchbox: {
    marginRight: theme.spacing(6.5)
  },
  grid: {
    marginLeft: theme.spacing(2)
  },
  card: {
    backgroundColor: theme.palette.grey[200],
    borderColor: 'rgba(0,0,0,0.12)',
    borderRadius: theme.spacing(1),
    marginLeft: theme.spacing(0.5),
    marginTop: theme.spacing(2),
    width: theme.spacing(25)
  },
  media: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(0),
    height: theme.spacing(15),
    display: 'flex'
  },
  collectorIcon: {
    background: theme.skelton?.color,
    marginLeft: theme.spacing(7),
    height: theme.spacing(11),
    width: theme.spacing(11),
    alignSelf: 'center',
    display: 'flex'
  },
  icon: {
    background: theme.skelton?.color,
    marginLeft: 'auto',
    marginRight: theme.spacing(1.5),
    marginTop: theme.spacing(1),
    height: theme.spacing(3),
    width: theme.spacing(3),
    justifyContent: 'flex-end'
  },
  title: {
    background: theme.skelton?.color,
    marginBottom: theme.spacing(1.25),
    borderRadius: theme.spacing(0.5),
    width: '75%',
    height: theme.spacing(2.75)
  },
  text: {
    background: theme.skelton?.color,
    margin: theme.spacing(0, 0, 2, 0),
    borderRadius: theme.spacing(0.5),
    width: '40%',
    height: theme.spacing(2)
  },
  searchContainer: {
    display: 'flex',
    height: theme.spacing(4.5),
    margin: theme.spacing(2, 1.5, 0, 1),
    width: '85%'
  },
  input: {
    backgroundColor: theme.palette.grey[300],
    borderRadius: theme.spacing(0.5),
    '& .MuiInputBase-input::placeholder': {
      opacity: 0.9
    },
    fontWeight: 600,
    fontSize: theme.typography.body2.fontSize
  },
  iconSearch: {
    opacity: 0.9,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(-1)
  },
  iconDropDown: {
    marginRight: theme.spacing(1)
  },
  selector: {
    margin: theme.spacing(3.75, 2, 1.5, 2),
    height: theme.spacing(4.75),
    width: '10%'
  },
  menuItem: {
    display: 'flex',
    background: theme.skelton?.color,
    width: '60%',
    height: theme.spacing(3),
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(1)
  }
}));

export const UnifiedCollectorListPageSkeleton: React.FC = () => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <div className={classes.search}>
        <div className={classes.searchContainer}>
          <InputBase
            data-testid="search-box"
            className={classes.input}
            placeholder={'Search'}
            startAdornment={
              <InputAdornment position="start">
                <SearchSharpIcon className={classes.iconSearch} />
              </InputAdornment>
            }
            endAdornment={
              <InputAdornment position="end">
                <ArrowDropDownIcon className={classes.iconDropDown} />
              </InputAdornment>
            }
            fullWidth
          />
        </div>
        <Select
          displayEmpty
          data-testid="selector"
          className={classes.selector}
        >
          <MenuItem>
            <Skeleton className={classes.menuItem}></Skeleton>
          </MenuItem>
        </Select>
      </div>
      <Grid
        container
        spacing={1}
        className={classes.grid}
        data-testid="collector-list-page-skeleton"
      >
        {Array.from(new Array(5)).map((_item, index) => (
          <Grid item key={index}>
            <Card
              className={classes.card}
              elevation={0}
              variant="outlined"
              data-testid="collector-note-skeleton"
            >
              <Box className={classes.media}>
                <Skeleton
                  className={classes.collectorIcon}
                  variant="circular"
                />
                <Skeleton className={classes.icon} variant="circular" />
              </Box>
              <CardContent>
                <Skeleton className={classes.title} variant="rectangular" />
                <Box>
                  <Skeleton className={classes.text} variant="rectangular" />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
